import React from "react";
import Label from "../widgets/Label";
import Select from "../widgets/Select";
import TextArea from "../widgets/TextArea";
import Input from "../widgets/Input";
import TagInput from "../widgets/TagInput";
import DateInput from "../widgets/DateInput";




const Field = ({fieldValues, adata, onFieldEdit, errorMessage, currentRound, hasError}) => {

    const value = fieldValues[adata.fieldName]

    const renderWidget = () => {
        switch (adata.type) {
            case "date":
            case "dateD":
            case "dateF":
            case "dateFF":
                let dd = null
                if(adata.typeRules) {
                    dd = adata.typeRules.defaultDate(currentRound ? currentRound.visit_date : null)
                }

                return <DateInput
                    onFieldEdit={onFieldEdit}
                    value={value}
                    adata={adata}
                    defaultDate={dd}
                    hasError={hasError}
                />
            case "nombre":
                return <Input
                    type="number"
                    value={value}
                    onChange={e => {
                        onFieldEdit(adata.fieldName, e.target.value)
                    }}
                />
            case "text":
                return <TextArea
                    rows={2}
                    value={value}
                    onChange={e => {
                        onFieldEdit(adata.fieldName, e.target.value)
                    }}
                />
            case "codePostal":
                return <TextArea
                    rows={2}
                    value={value}
                    onChange={e => {
                        onFieldEdit(adata.fieldName, e.target.value)
                    }}
                />
            case "choix_multiple_non_ex":

                return <TagInput
                    itemChoices={adata.choice}
                    items={value || []}
                    onChange={updatedItemList => {
                        onFieldEdit(adata.fieldName, updatedItemList)
                    }}
                />
            case "choix_multiples":
            case "choice":
                return <Select
                    onChange={e => {
                        onFieldEdit(adata.fieldName, e.target.value)
                    }}
                    value={value}
                >
                    <option value={""}>choisir...</option>
                    {
                        adata.choice.map(c => <option key={c} value={c}>{c}</option>)
                    }
                </Select>
            case "boolean":
                return <input
                    type="checkbox"
                    checked={value}
                    onChange={e => {
                        onFieldEdit(adata.fieldName, e.target.checked)
                    }}
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                />

        }
    }

    const unitDisplay = adata.unit ? `(${adata.unit})` : ''

    return <div className={"datepicker-error"}>
        <Label text={`${adata.label} ${unitDisplay}`}/>
        {renderWidget()}
        {errorMessage && <p className="mt-2 text-sm text-red-600 dark:text-red-500">{errorMessage}</p>}
    </div>
}


export default Field